// Initialize Artisn
import useSetupAnalytics from "./useSetupAnalytics";

const useSetupArtisn = () => {
  useSetupAnalytics();
};

export default useSetupArtisn;
